class FAQs extends HTMLElement {
  constructor() {
    super();

    this.filter = document.getElementById('haloFAQsFilter');
    this.faqsPopup = document.getElementById('halo-faqs-popup');
    this.onClickHeaderButtonHandler = this.onClickHeaderButtonHandler.bind(this);
    this.onBodyClickEvent = this.onBodyClickEvent.bind(this);

    if (this.filter) {
      this.filterToggle = this.filter.querySelector('[data-faqs-filter]');
      this.filterDropdown = this.filter.querySelector('.faqs-filterDropdown-menu');
      this.filterDropdownArrow = this.filterToggle?.querySelector('[data-dropdown-arrow]');

      if (this.filterToggle) {
        this.filterToggle.addEventListener('click', this.onClickFilterHandler.bind(this));
      }

      if (this.filterDropdown?.querySelector('.text')) {
        this.filterDropdown.querySelectorAll('.text').forEach((filterButton) => {
          filterButton.addEventListener('click', this.onClickFilterButtonHandler.bind(this));
        });
      }
    }

    if (this.querySelector('.faqs')) {
      this.querySelectorAll('.card-header').forEach((headerButton) => {
        headerButton.addEventListener('click', this.onClickHeaderButtonHandler);
      });
    }

    if (!document.body.classList.contains('template-index')) {
      document.body.addEventListener('click', this.onBodyClickEvent);
    }

    // Defer every embed until its accordion opens (critical on mobile: 80+ YouTube iframes).
    this.deferEmbeds(this);
  }

  deferEmbeds(root) {
    (root || this).querySelectorAll('.faqs-item .card-body iframe[src]').forEach((iframe) => {
      const src = iframe.getAttribute('src');
      if (!src || iframe.dataset.lazySrc) return;
      iframe.dataset.lazySrc = src;
      iframe.removeAttribute('src');
      iframe.setAttribute('loading', 'lazy');
      iframe.setAttribute('data-tl-lazy-embed', '1');
    });
  }

  loadEmbeds(panel) {
    if (!panel) return;
    panel.querySelectorAll('iframe[data-lazy-src]').forEach((iframe) => {
      if (iframe.getAttribute('src')) return;
      iframe.setAttribute('src', iframe.dataset.lazySrc);
      iframe.addEventListener(
        'load',
        () => {
          this.refreshPanelHeight(panel);
        },
        { once: true }
      );
    });
  }

  unloadEmbeds(panel) {
    if (!panel) return;
    panel.querySelectorAll('iframe[data-lazy-src]').forEach((iframe) => {
      iframe.removeAttribute('src');
    });
  }

  refreshPanelHeight(panel) {
    if (!panel || !panel.style.maxHeight) return;
    panel.style.maxHeight = panel.scrollHeight + 'px';
  }

  onClickFilterHandler() {
    if (this.filterDropdown.classList.contains('is-show')) {
      this.filterDropdown.classList.remove('is-show');
      this.filterDropdownArrow?.classList.remove('active');
    } else {
      this.filterDropdown.classList.add('is-show');
      this.filterDropdownArrow?.classList.add('active');
    }
  }

  onClickFilterButtonHandler(event) {
    var btn = event.target.closest('li');

    if (!btn.classList.contains('is-active')) {
      var filterValue = btn.getAttribute('data-value'),
        filterText = event.target.innerText;

      this.filterToggle.querySelector('.text').innerText = filterText;

      this.filterDropdown.querySelectorAll('li').forEach((element) => {
        element.classList.remove('is-active');
      });

      btn.classList.add('is-active');

      if (filterValue !== undefined && filterValue !== null) {
        this.querySelectorAll('.faqs-paragraph').forEach((element) => {
          var id = element.getAttribute('id');

          if (id == filterValue) {
            element.classList.remove('is-hidden');
            element.classList.add('is-active');
          } else {
            element.classList.remove('is-active');
            element.classList.add('is-hidden');
          }
        });
      } else {
        this.querySelectorAll('.faqs-paragraph').forEach((element) => {
          element.classList.remove('is-hidden', 'is-active');
        });
      }

      this.filterDropdown.classList.remove('is-show');
      this.filterDropdownArrow?.classList.remove('active');
    }
  }

  onClickHeaderButtonHandler(event) {
    const btn = event.currentTarget;
    const content = btn.nextElementSibling;
    if (!content) return;

    const willOpen = btn.classList.contains('collapsed');
    btn.classList.toggle('collapsed');

    if (!willOpen) {
      // Closing
      content.style.maxHeight = null;
      this.unloadEmbeds(content);
      return;
    }

    // Opening — mount video only for this item
    this.loadEmbeds(content);
    // Reserve 16:9 space before iframe paints so panel doesn't clip
    const reserve = Math.round(content.clientWidth * (9 / 16)) + 48;
    content.style.maxHeight = Math.max(content.scrollHeight, reserve) + 'px';
    requestAnimationFrame(() => this.refreshPanelHeight(content));
  }

  onBodyClickEvent(event) {
    if (!this.filterDropdown) return;
    if (event.target.closest('[data-faqs-filter]') != null) return;
    if (this.filterDropdown.classList.contains('is-show')) {
      this.filterDropdown.classList.remove('is-show');
      this.filterDropdownArrow?.classList.remove('active');
    }
  }
}

if (!customElements.get('faqs-item')) {
  customElements.define('faqs-item', FAQs);
}
